import React from "react";
import "./Fallback.css";

const Fallback = () => (
  <div className="fallback-container">
    <div />
    <div />
    <div />
    <div />
  </div>
);

export default Fallback;
